import { css } from 'lit'
import inputGlobalStyles from '../src/ui/styles/input-global-styles.js'
import buttonGlobalStyles from '../src/ui/styles/button-global-styles.js'
import cardGlobalStyles from '../src/ui/styles/card-global-styles.js'

const globalStyles = css`
  ${inputGlobalStyles}
  ${buttonGlobalStyles}
  ${cardGlobalStyles}
  :host {
    font-family: var(--primary-font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }
  .gradient-title {
    font-family: var(--primary-font-family);
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.024px;
    background: var(
      --kula-gradient,
      linear-gradient(134deg, #3a7f9a 0%, #a1cee1 100%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .label-secondary {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.012px;
  }
  .label-lg {
    font-family: var(--primary-font-family);
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
  }
  .background-pattern {
    background-image: url('assets/svg/background-gradient.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 100vh;
  }
  back-arrow {
    margin-top: 8px;
  }
  [hide] {
    display: none;
  }
`

export default globalStyles
